import * as React from "react"
import { TopTransactionsComponent } from "src/frontend/components/Shared/Layout/Components/Lists/TopTransactionsComponent"
import { useTopTransactionsLiveData } from "src/frontend/components/Shared/Layout/Components/Lists/useTopTransactionsLiveData"
import { type ComponentSize } from "src/frontend/components/Shared/Layout/ComponentSize"
import { useConfigOriginOverride } from "src/frontend/components/Shared/Layout/hooks/useConfigOriginOverride"
import {
  type MatchedComponent,
  type SizingProps,
} from "src/frontend/components/Shared/Layout/types"

/*
  INTERFACES
*/

export type TopTransasctionsProps = SizingProps & {
  component: MatchedComponent<"topTransactions">
  componentSize: ComponentSize
}

/*
  COMPONENTS
*/

export const TopTransactions: React.FC<TopTransasctionsProps> = ({ component, componentSize }) => {
  const overriddenConfig = useConfigOriginOverride(component.config.topTransactions, 1)
  const config = React.useMemo(
    () => ({ ...component.config, topTransactions: overriddenConfig }),
    [component.config, overriddenConfig]
  )

  const { data, loading } = useTopTransactionsLiveData(overriddenConfig, component.config.type)

  return (
    <TopTransactionsComponent
      config={config}
      componentSize={componentSize}
      transactions={data?.transactions}
      loading={loading}
    />
  )
}
